import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getVideoInformation as getVideoInformationApi } from "@/services/apiLectureContent";
import { useEffect } from "react";

export function useVideoInformation({ courseId, lectureId, videoId }) {
  const queryClient = useQueryClient();

  const {
    isPending,
    data: videoInformation,
    isError,
    error,
    isSuccess,
  } = useQuery({
    queryKey: ["video", courseId, lectureId, videoId],
    queryFn: () =>
      getVideoInformationApi({
        courseId,
        lectureId,
        videoId,
      }),
    retry: false,
    refetchIntervalInBackground: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    gcTime: 0,
    cacheTime: 0,
    enabled: !!courseId && !!lectureId && !!videoId,
  });

  useEffect(
    function () {
      queryClient.removeQueries({
        type: "inactive",
        queryKey: ["video", courseId, lectureId, videoId],
        exact: true,
      });
    },
    [queryClient, courseId, lectureId, videoId]
  );

  if (isSuccess) {
    queryClient.refetchQueries({
      queryKey: ["lectureContent"],
    });
  }
  return { isPending, videoInformation, isError, error };
}
